import { loaderCreator } from '@/vuex/plugins/loaderPlugin/_base'
import { loadGtm } from '@/utils/gtm'

export default loaderCreator(() => {
  loadGtm()
})
